<template>
	<div class="container-fluid">
		<service-toolbar></service-toolbar>

		<locates v-if="'id' in $store.service" :service-id="$store.service.id"></locates>
	</div>
</template>
<script type="text/javascript">
import ServiceToolbar from "./ServiceToolbar"
import ServiceMixins from "@/mixins/ServiceMixins.js"
import Locates from "@/pages/Locates"

export default {
	components: {
		ServiceToolbar,
		Locates
	},
	mixins: [ServiceMixins],
	created() {
		this.setServiceIfNotSet()
	}
}
</script>